import { useTranslation } from 'react-i18next';

import type { ChatAdapter } from '@azure/communication-react';
import { IonGrid, IonRow, IonText } from '@ionic/react';

import { useAppSelector } from '../../store';
import { TSButton } from '../atomic/TSButton/TSButton';

export const AdvocateEndChat = ({
  endChatModal,
  closeModal,
}: {
  endChatModal: () => Promise<void>;
  closeModal: () => void;
  chatAdapter: ChatAdapter | undefined;
  isAdvocate: boolean;
  advocateSentFirstMsg: boolean;
}) => {
  const { t } = useTranslation();
  const advocateReportedAbuse = useAppSelector((state) => state.advocateChatSlice.advocateReportedAbuse);

  return (
    <IonGrid className="ion-no-padding guest-end-chat-wrapper">
      <IonRow>
        <IonText className="title-medium-extra text-bold modal-title">{t('advocateChatPage.endChatTitle')}</IonText>
      </IonRow>
      <IonRow className="ion-margin-vertical">
        <IonText>
          {t(advocateReportedAbuse ? 'advocateChatPage.endReportedChatBody' : 'advocateChatPage.endChatBody')}
        </IonText>
      </IonRow>
      <IonRow className="ion-margin-bottom ion-justify-content-center">
        <TSButton id="agree" variant="black" onClick={endChatModal}>
          {t('generic.agree')}
        </TSButton>
      </IonRow>
      <IonRow className="ion-justify-content-center">
        <TSButton variant="white" onClick={closeModal}>
          {t('generic.cancel')}
        </TSButton>
      </IonRow>
    </IonGrid>
  );
};
